export interface SurveyListRequest {
  status: string;
  pageSize: number;
  page: number;
}

export interface SurveyListResponse {
  message: string;
  response: SurveyListRowsResponse;
}

export interface SurveyListRowsResponse {
  count: number;
  rows: SurveyDetails[];
}

export interface SurveyDetails {
  id: number;
  status: string;
  completedDate?: string;
  updatedAt?: string;
  MasterSurvay: MasterSurveyDetails;
  score: number;
}

interface SurveyQuota {
  survey_quota_type: string;
  number_of_respondents: number;
  conversion?: number;
  questions?: Record<string, unknown>[];
  survey_quota_id?: number;
}

interface MasterSurveyDetails {
  surveyNumber: number;
  surveyName: string;
  lengthOfInterview: number;
  category: string;
  url: string;
  reward: number;
  endDate: string;
  conversion: number;
  score: number;
  total_remaining: number;
  quotas?: SurveyQuota[];
  revenue_per_click: number | null;
  provider: {
    appKey: string;
  };
  status: string;
}

export interface SurveyListStateProps {
  isFetchingNewSurveys: boolean;
  isFetchingCompletedSurveys: boolean;
  newsurveys: SurveyListRowsResponse;
  completedsurveys: SurveyListRowsResponse;
  isError: boolean;
}

export const initialState: SurveyListStateProps = {
  isFetchingNewSurveys: false,
  isFetchingCompletedSurveys: false,
  isError: false,
  newsurveys: {
    count: 0,
    rows: [],
  },
  completedsurveys: {
    count: 0,
    rows: [],
  },
};

export interface IncreaseClickResponse {
  message: string;
  link: string;
}

export interface UpdateSurveyRequest {
  userId?: string;
  surveyId?: string;
  status: string;
  dispositionId?: string;
  statusId?: string;
  marketplaceStatus?: string | null;
  clientStatus?: string | null;
  rpi?: string | null;
  hash?: string;
  mid?: string;
  pid?: string;
  ProofCPI?: string | null;
  cintQuestions?: Record<string, string>;
  tolunaUrl?: string; // This field is added for Toluna
}
